// Maps parsed SOC action labels (from soc-action-parser.ts) to action_type identifiers.
// Used to match parsed actions to available ResponseActionDefinitions on the ticket.

import { ResponseActionDefinition } from '../models/ticket.models';

const ACTION_TYPE_MAP: Record<string, string> = {
  'Full Disk Scan': 'scan_endpoints',
  'Network Isolation': 'isolate_endpoint',
  'File Quarantine': 'quarantine_file',
  'Block': 'block_ip',
  'Rule Removal': 'remove_rule',
  'Password Reset': 'force_password_reset',
  'Session Revocation': 'revoke_sessions',
  'MFA Enforcement': 'enforce_mfa',
  'Account Disabled': 'disable_user',
  'Threat Remediation': 'remediate_threat',
  'Email Quarantine': 'quarantine_email',
  'Domain Block': 'block_domain',
};

/**
 * Get the action_type identifier for a parsed SOC action label.
 */
export function getActionType(label: string): string | null {
  return ACTION_TYPE_MAP[label] ?? null;
}

/**
 * Find a matching ResponseActionDefinition for a parsed SOC action label.
 */
export function matchActionDefinition(
  label: string,
  availableActions: ResponseActionDefinition[],
): ResponseActionDefinition | null {
  const actionType = getActionType(label);
  if (!actionType) return null;
  return availableActions.find((a) => a.action_type === actionType) ?? null;
}
